import { render } from "./cpt-scan-option.vue?vue&type=template&id=6b4c4641"
import script from "./cpt-scan-option.vue?vue&type=script&lang=js"
export * from "./cpt-scan-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__